import React from 'react';
import ContainerTranslation from "../partials/ContainerTranslation";
import IconDocumentStatus from "./IconDocumentStatus";
import { withLocalize } from "react-localize-redux";
class Progress extends React.Component {


  renderDocumentStatus() {


      return (<IconDocumentStatus progression={this.props.progression}
                                  validationInformation={this.props.validationInformation}
                                  infovisible="true"
                                  kind={this.props.kind}
            />)

  }


  render(){


    const title = this.props.title;
    const width = this.props.progression;
    

    let fa;
    if(this.props.gender === "Male"){
      fa = <i className={"fas fa-male"} style={{marginRight:"10px"}}></i>
    }else if(this.props.gender === "Female"){
      fa = <i className={"fas fa-female"} style={{marginRight:"10px"}}></i>
    }else{
      fa = null
    }
    // style={{width: 'calc(100% - 200px)'}}


    return (
      <div className="progress" >
        <div>
          <div className="progress-header">
            <h3>
              {fa}
              {title} 
            </h3>
            <h3>{Math.floor(width)} <ContainerTranslation id={"nav." + ['completed']}/></h3>
          </div>
          <div className="progress-bar">
            <div className="progress-line" style={{width : width+"%"}}></div>
          </div>
          {this.props.hideIcon ? null : this.renderDocumentStatus()}
        </div>
      </div>
    )
  }
}


export default withLocalize(Progress);